import React from 'react'
import { generatePath } from "react-router"
import { HIGHLIGHT, AD, WEISCHER, TITLE, TEXT, IMAGE, ADVERTISEMENT, METRO, NEWSLETTER_IMAGE, NEWSLETTER_TEXT } from '../../../constants/itemTypes'
import AddAdContainer from './AddAdContainer'
import AddHighlightContainer from './AddHighlightContainer'
import AddImageContainer from './AddImageContainer'
import AddTextContainer from './AddTextContainer'
import AddTitleContainer from './AddTitleContainer'
import AddWeischerAdContainer from './AddWeischerAdContainer'
import AddAdvertisementsContainer from './AddAdvertisementsContainer'
import AddMetroContainer from './AddMetroContainer'
import AddNewsletterElementContainer from './AddNewsletterElementContainer'

const PageAddItemContainer = ({match, goBackPath}) => {
    const { itemType, weischerType, printType, campaignId } = match.params
    const closePagePath = generatePath(goBackPath, match.params)

    if(HIGHLIGHT === itemType) {
        return <AddHighlightContainer
            closePagePath={closePagePath}
        />
    } else if (AD === itemType) {
        return <AddAdContainer
            closePagePath={closePagePath}
        />
    } else if(ADVERTISEMENT === itemType)  {
        return <AddAdvertisementsContainer  
            params={match.params}
            closePagePath={closePagePath}
        />
    } else if (WEISCHER === itemType) {
        return <AddWeischerAdContainer
            closePagePath={closePagePath}
            weischerType={weischerType}
        />
    } else if (TITLE === itemType) {
        return <AddTitleContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if (TEXT === itemType && printType) {
        return <AddTextContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if (IMAGE === itemType && printType) {
        return <AddImageContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if(METRO === itemType) {
        return <AddMetroContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if((NEWSLETTER_TEXT === itemType && campaignId) || (NEWSLETTER_IMAGE === itemType && campaignId)) {
        return <AddNewsletterElementContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else {
        return <div>Error</div>
    }
}

export default PageAddItemContainer